__turbopack_context__.v({
  "explaining": "TeaserClusterVignette-module-scss-module__j2AWXW__explaining",
  "fadedText": "TeaserClusterVignette-module-scss-module__j2AWXW__fadedText",
  "feedItemVignette": "TeaserClusterVignette-module-scss-module__j2AWXW__feedItemVignette",
  "licensedArticle": "TeaserClusterVignette-module-scss-module__j2AWXW__licensedArticle",
  "longform": "TeaserClusterVignette-module-scss-module__j2AWXW__longform",
  "native": "TeaserClusterVignette-module-scss-module__j2AWXW__native",
  "prefix": "TeaserClusterVignette-module-scss-module__j2AWXW__prefix",
  "premium": "TeaserClusterVignette-module-scss-module__j2AWXW__premium",
  "titleLink": "TeaserClusterVignette-module-scss-module__j2AWXW__titleLink",
  "uncoloredLink": "TeaserClusterVignette-module-scss-module__j2AWXW__uncoloredLink",
});
